// Klaviyo BIS custom element
const KLAVIYO_BIS_ELEMENT = "klaviyo-bis";

const bisAttributes = {
  title: `data-${KLAVIYO_BIS_ELEMENT}-title`,
  body: `data-${KLAVIYO_BIS_ELEMENT}-body`,
  close: `data-${KLAVIYO_BIS_ELEMENT}-close`,
  open: `data-${KLAVIYO_BIS_ELEMENT}-open`,
  requestUrl: `data-${KLAVIYO_BIS_ELEMENT}-url`,
  responseMessage: `data-${KLAVIYO_BIS_ELEMENT}-response`,
};

class KlaviyoBIS extends HTMLElement {
  constructor() {
    super();
    this.$closeElements = this.querySelectorAll(`[${bisAttributes.close}]`);
    this.$formElement = this.querySelector("form");
    if (!this.$formElement) throw new Error("[KlaviyoBIS] Form not found");
  }

  connectedCallback() {
    this._setCloseEvent();
    this._submitForm();
    document.addEventListener(
      "click",
      (event) => {
        this._setOpenEvent(event);
      },
      false
    );
  }

  async _setOpenEvent(event) {
    const $openElement = event.target.closest(`[${bisAttributes.open}]`);
    if (!$openElement) return;

    event.preventDefault();
    this._toggle(true);
    this._loading(true);
    const form = $openElement.closest("form");
    const requestURL = $openElement.getAttribute(bisAttributes.requestUrl);
    const selectedVariantId = form?.querySelector("[name='id']")?.value || 0;

    const url = `${requestURL}${requestURL.indexOf("?") > -1 ? "&" : "?"}${
      parseInt(selectedVariantId, 10) > 0 ? `variant=${selectedVariantId}&` : ""
    }section_id=${KLAVIYO_BIS_ELEMENT}`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("[KlaviyoBIS] Response error");

      const html = await response.text();
      this._replaceHTML(html);
      this._loading(false);
    } catch (error) {
      throw new Error(`[KlaviyoBIS] ${error}`);
    }
  }

  _replaceHTML(html) {
    const newDocument = new DOMParser().parseFromString(html, "text/html");

    const idSuffix = this.id ? `_${this.id}` : "";

    const $newElement = newDocument.querySelector(
      `${KLAVIYO_BIS_ELEMENT}${idSuffix}`
    );

    if (!$newElement) throw new Error("[KlaviyoBIS] Element not found");
    this.querySelector(`[${bisAttributes.body}]`).innerHTML =
      $newElement.querySelector(`[${bisAttributes.body}]`).innerHTML;

    this.querySelector(`[${bisAttributes.title}]`).innerHTML =
      $newElement.querySelector(`[${bisAttributes.title}]`).innerHTML;
  }

  async _submitForm() {
    this.$formElement.addEventListener("submit", async (event) => {
      event.preventDefault();

      const formData = new FormData(this.$formElement);

      if (formData.get("subscribe-to-newsletter")) {
        this._subscribeToNewsletter(
          formData.get("subscribe-to-newsletter"),
          formData.get("email")
        );
      }

      this._reset();
      this._loading(true);
      try {
        const payload = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: formData.get("email"),
                  },
                },
              },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${formData.get("variant")}`,
                },
              },
            },
          },
        };

        const response = await fetch(this.$formElement.action, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            revision: "2025-01-15",
          },
          body: JSON.stringify(payload),
        });

        if (response?.status === 202) {
          this._success(true);
        } else {
          this._error(true);
        }

        this._loading(false);
      } catch (error) {
        this._loading(false);
        throw new Error(`[KlaviyoBIS] ${error}`);
      }
    });
  }

  async _subscribeToNewsletter(listId, email) {
    try {
      const response = await fetch(this.$formElement.dataset.newsletterAction, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          revision: "2025-01-15",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: { email },
                },
              },
            },
            relationships: {
              list: { data: { type: "list", id: listId } },
            },
          },
        }),
      });

      if (response?.status === 202) {
        // success
      } else {
        // error
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`[KlaviyoBIS] ${error}`);
    }
  }

  _setCloseEvent() {
    const _self = this;
    document.addEventListener("keyup", (event) => {
      if (event.code?.toUpperCase() === "ESCAPE") _self._toggle(false);
    });
    if (!this.$closeElements || !this.$closeElements.length) return;

    this.$closeElements.forEach((element) =>
      element.addEventListener("click", (e) => {
        e.preventDefault();
        _self._toggle(false);
      })
    );
  }

  _toggle(open) {
    this._reset();
    if (open) this.setAttribute("open", "");
    else this.removeAttribute("open");
  }

  _loading(active) {
    if (active) this.setAttribute("loading", "");
    else this.removeAttribute("loading");
  }

  _success(active) {
    if (active) this.setAttribute("success", "");
    else this.removeAttribute("success");
  }

  _error(active) {
    if (active) this.setAttribute("error", "");
    else this.removeAttribute("error");
  }

  _reset() {
    this._error(false);
    this._success(false);
    this._loading(false);
  }
}

if (!customElements.get(KLAVIYO_BIS_ELEMENT)) {
  customElements.define(KLAVIYO_BIS_ELEMENT, KlaviyoBIS);
}


